if (!customElements.get('stock-display')) {
    const DRAWER_MODAL_TRANSITION_MS = 320;

    class StockDisplay extends HTMLElement {
        productAvailabilityCache = null;
        
        constructor() {
            super();
            this.currentStoreCookie = this.getCookie('currentStore');
            this.stockDisplayQueryId = this.dataset.stockDisplayQueryId;
            this.blockClickCollect = this.dataset.blockClickCollect === 'true';
            this.storeNameElement = this.querySelector('.stock-display__store-name');
            this.storeCheckElement = this.querySelector('.stock-display__store-check');
            this.checkAvailabilityButton = this.querySelector('#stock-display__check-availability');
            this.storeButtonChevronElement = this.querySelector('#stock-display__store-button-chevron');
            this.inStorePanelElement = this.querySelector('#stock-display__in-store-panel');
            this.inStoreListElement = this.querySelector('#stock-display__in-store-list');
            this.inStoreTitleElement = this.querySelector('#stock-display__in-store-title');
            this.inStoreDescriptionElement = this.querySelector('#stock-display__in-store-description');
            this.inStorePanelOpen = false;
            this.currentWarehouseStatus = 'out-of-stock';
            this.inStoreAvailabilityModalElement = this.querySelector('#stock-display__availability-modal');
            this.inStoreAvailabilityModalListElement = this.querySelector('#stock-display__availability-modal-list');
            this.inStoreAvailabilityModalCloseButton = this.querySelector('#stock-display__availability-modal-close');
            this.inStoreAvailabilityModalBackdropElements = this.querySelectorAll('[data-availability-modal-close]');
            this.inStoreAvailabilityModalTriggerElement = null;
            this.storeSelectedContentElement = this.querySelector('#stock-display__store-selected-content');
            this.deliveryStatusElement = this.querySelector('#stock-display__status-delivery .stock-display__placeholder');
            this.selectedStoreNameElement = this.querySelector('#stock-display__selected-store-name');
            this.selectedStoreBadgeElement = this.querySelector('#stock-display__status-clickcollect-panel');
            this.selectedStoreReadyElement = this.querySelector('#stock-display__selected-store-ready');
            this.selectedStoreStatusElement = this.querySelector('.stock-display__store-selected-status');
            this.deliveryPanelElement = this.querySelector('.stock-display__panel--delivery');
            this.clickCollectPanelContainer = this.querySelector('.stock-display__panel--click-collect');
            this.storeSelectElement = this.querySelector('#stock-display__store-select');
            this.clickCollectStatusElement = this.querySelector('#stock-display__clickcollect-status');
            this.selectStoreButton = this.querySelector('#stock-display__select-store');
            this.changeStoreButton = this.querySelector('#stock-display__change-store');
            this.storeModalElement = this.querySelector('#stock-display__store-modal');
            this.storeModalListElement = this.querySelector('#stock-display__store-modal-list');
            this.storeModalCloseButton = this.querySelector('#stock-display__store-modal-close');
            this.storeModalBackdropElement = this.querySelector('[data-store-modal-close]');
            this.storeModalFooterHintElement = this.querySelector('#stock-display__store-modal-footer-hint');
            this.storeModalFooterSelectedElement = this.querySelector('#stock-display__store-modal-footer-selected');
            this.storeModalFooterWarningElement = this.querySelector('#stock-display__store-modal-footer-warning');
            this.storeModalCollectingNameElement = this.querySelector('#stock-display__store-modal-collecting-name');
            this.storeModalWarningDetailElement = this.querySelector('#stock-display__store-modal-warning-detail');
            this.storeModalConfirmButton = this.querySelector('#stock-display__store-modal-confirm');
            this.deliveryTabElement = this.querySelector('.stock-display__tab[data-tab="delivery"]');
            this.clickCollectTabElement = this.querySelector('.stock-display__tab[data-tab="click-collect"]');
            this.deliveryTabSublabelElement = this.deliveryTabElement?.querySelector('.stock-display__tab-sublabel');
            this.clickCollectTabSublabelElement = this.clickCollectTabElement?.querySelector('.stock-display__tab-sublabel');
            this.tabsElement = this.querySelector('#stock-display__tabs');
            this.fulfillmentElement = this.querySelector('#stock-display__fulfillment');
            this.panelAreaElement = this.querySelector('.stock-display__panel-area');
            this.inStoreOnlyBannerElement = this.querySelector('#stock-display__in-store-only-banner');
            this.backInStockPanelElement = this.querySelector('#stock-display__back-in-stock');
            this.deliveryIconElement = this.querySelector('#stock-display__icon-delivery');
            this.clickCollectIconElement = this.querySelector('#stock-display__icon-clickcollect');
            this.tabElements = this.querySelectorAll('.stock-display__tab');
            this.activeTab = 'delivery';
            this.initialDeliveryStateSet = false;
            this.storeModalTriggerElement = null;
            this.pendingModalStoreId = '';
            this.cartPickupStoreId = '';
            this.cartPickupStoreName = '';
            this.storeChoicesList = [];
            this.datajetLocations = null;
            this.locationsList = [];
            this.productAvailabilityPromise = null;
            this.currentProductId = this.dataset.productId;
            this.currentVariantId = this.dataset.variantId;
            this.currentLocationId = this.currentStoreCookie?.dataId ?? '';
            this.inventoryByVariantId = {};
            this.callStoreText = this.dataset.callStoreText;
            this.inStockText = this.dataset.inStockText;
            this.outOfStockText = this.dataset.outOfStockText;
            this.init();
        }
        
        init() {
            const productId = this.currentProductId;
            const variantId = this.currentVariantId;
            const locationId = this.currentLocationId;
            this.loadProductAvailability(productId).then(() => {
                this.buildStoreList(variantId);
                this.setCurrentStore();
                this.setStockAvailability(variantId, locationId);
            });
            this.storeModalEvent();
            this.storeCheckEvent();
            this.inStoreAvailabilityModalEvent();
            this.tabEvent();
            this.onVariantChange();
        }

        tabEvent() {
            this.tabElements.forEach(tab => {
                tab.addEventListener('click', () => {
                    if (this.isFullyOutOfStockOnline(this.currentVariantId, this.currentWarehouseStatus)) return;
                    this.switchToTab(tab.dataset.tab);
                });
            });
        }

        clearActiveTabState() {
            this.activeTab = null;
            this.tabElements.forEach((tabEl) => {
                tabEl.classList.remove('stock-display__tab--active');
                tabEl.setAttribute('aria-selected', 'false');
            });
        }

        isFullyOutOfStockOnline(variantId, warehouseStatus) {
            return this.isInStoreOnlyMode(variantId, warehouseStatus);
        }

        ensureComponentVisible() {
            this.style.removeProperty('display');
        }

        showBackInStockPanel() {
            if (!this.backInStockPanelElement) return;
            this.toggleShow(this.backInStockPanelElement);
            this.backInStockPanelElement.classList.remove('stock-display__panel--hidden');
            this.backInStockPanelElement.setAttribute('aria-hidden', 'false');
        }

        hideBackInStockPanel() {
            if (!this.backInStockPanelElement) return;
            this.toggleHide(this.backInStockPanelElement);
            this.backInStockPanelElement.classList.add('stock-display__panel--hidden');
            this.backInStockPanelElement.setAttribute('aria-hidden', 'true');
        }

        updateBackInStockForm(variantId, warehouseStatus) {
            const fullyOutOfStockOnline = this.isFullyOutOfStockOnline(variantId, warehouseStatus);
            const inStoreOnlyWithRetail = this.isAvailableInStoreOnly(variantId, warehouseStatus);

            if (!this.backInStockPanelElement) return;

            if (fullyOutOfStockOnline && !inStoreOnlyWithRetail) {
                this.showBackInStockPanel();
                return;
            }

            if (inStoreOnlyWithRetail) {
                this.hideBackInStockPanel();
                this.hidePanelLayer(this.deliveryPanelElement);
                this.hidePanelLayer(this.clickCollectPanelContainer);
                return;
            }

            this.hideBackInStockPanel();

            if (this.deliveryTabElement) {
                this.deliveryTabElement.disabled = false;
                this.deliveryTabElement.setAttribute('aria-disabled', 'false');
            }

            const activeTab = this.activeTab || 'delivery';
            if (activeTab === 'click-collect') {
                this.hidePanelLayer(this.deliveryPanelElement);
                this.showPanelLayer(this.clickCollectPanelContainer);
            } else {
                this.showPanelLayer(this.deliveryPanelElement);
                this.hidePanelLayer(this.clickCollectPanelContainer);
            }
        }

        switchToTab(selectedTab) {
            if (selectedTab === this.activeTab) return;
            if (this.isFullyOutOfStockOnline(this.currentVariantId, this.currentWarehouseStatus)) return;
            if (selectedTab === 'click-collect' && this.clickCollectTabElement?.disabled) return;

            this.activeTab = selectedTab;
            this.tabElements.forEach(tabEl => {
                const isActive = tabEl.dataset.tab === selectedTab;
                tabEl.classList.toggle('stock-display__tab--active', isActive);
                tabEl.setAttribute('aria-selected', isActive ? 'true' : 'false');
            });

            if (selectedTab === 'delivery') {
                this.showPanelLayer(this.deliveryPanelElement);
                this.hidePanelLayer(this.clickCollectPanelContainer);
            } else {
                this.hidePanelLayer(this.deliveryPanelElement);
                this.showPanelLayer(this.clickCollectPanelContainer);
            }

            this.refreshAddToCartButton();
        }

        setPanelStatus(element, iconElement, status, inStockMessage, outOfStockMessage) {
            if (!element) return;

            const isAvailable = status === 'in-stock' || status === 'low-in-stock' || status === 'available';
            element.textContent = isAvailable ? inStockMessage : outOfStockMessage;

            if (iconElement) {
                iconElement.classList.toggle('stock-display__panel-icon--success', isAvailable);
                iconElement.classList.toggle('stock-display__panel-icon--error', !isAvailable);
            }
        }

        setClickCollectPanelWhenNoStore() {
            this.showPanelLayer(this.storeSelectElement);
            this.hidePanelLayer(this.clickCollectStatusElement);
        }

        setClickCollectPanelWithStore(displayName) {
            this.hidePanelLayer(this.storeSelectElement);
            this.showPanelLayer(this.clickCollectStatusElement);
            if (displayName && this.selectedStoreNameElement) {
                this.selectedStoreNameElement.textContent = displayName;
            }
        }

        updateDeliveryTabState(warehouseStatus) {
            if (!this.deliveryTabElement || !this.deliveryTabSublabelElement) return;

            const isAvailable = warehouseStatus === 'in-stock' || warehouseStatus === 'available' || warehouseStatus === 'low-in-stock';
            this.deliveryTabElement.classList.toggle('stock-display__tab--unavailable', !isAvailable);
            this.deliveryTabSublabelElement.textContent = isAvailable ? '1-2 business days' : 'Out of stock';
        }

        updateClickCollectTabState(clickCollectAvailable) {
            if (!this.clickCollectTabElement || !this.clickCollectTabSublabelElement) return;

            this.clickCollectTabElement.classList.toggle('stock-display__tab--unavailable', !clickCollectAvailable);
            this.clickCollectTabElement.disabled = !clickCollectAvailable;
            this.clickCollectTabElement.setAttribute('aria-disabled', clickCollectAvailable ? 'false' : 'true');
            this.clickCollectTabSublabelElement.textContent = clickCollectAvailable ? 'Ready in 2 hours' : 'Out of stock';

            if (!clickCollectAvailable && this.activeTab === 'click-collect') {
                this.activeTab = 'delivery';
                this.tabElements.forEach((tabEl) => {
                    const isActive = tabEl.dataset.tab === 'delivery';
                    tabEl.classList.toggle('stock-display__tab--active', isActive);
                    tabEl.setAttribute('aria-selected', isActive ? 'true' : 'false');
                });

                if (!this.isFullyOutOfStockOnline(this.currentVariantId, this.currentWarehouseStatus)) {
                    this.showPanelLayer(this.deliveryPanelElement);
                    this.hidePanelLayer(this.clickCollectPanelContainer);
                }
            }
        }

        isDeliveryAvailable(warehouseStatus) {
            return this.normalizeStatus(warehouseStatus) === 'available';
        }

        hasClickCollectAvailableAnywhere(variantId) {
            if (this.blockClickCollect) return false;

            const variantInventory = this.getVariantInventory(variantId);

            return this.locationsList.some((location) => {
                if (!this.isStoreEligibleForModal(location)) return false;
                return this.isClickCollectAvailableForLocation(
                    this.getLocationInventory(variantInventory, location.id)
                );
            });
        }

        isInStoreOnlyMode(variantId, warehouseStatus) {
            return !this.isDeliveryAvailable(warehouseStatus)
                && !this.hasClickCollectAvailableAnywhere(variantId);
        }

        isAvailableInStoreOnly(variantId, warehouseStatus) {
            return this.isInStoreOnlyMode(variantId, warehouseStatus)
                && this.hasRetailStoreStock(variantId);
        }

        isFullyOutOfStockEverywhere(variantId, warehouseStatus) {
            return this.isInStoreOnlyMode(variantId, warehouseStatus)
                && !this.hasRetailStoreStock(variantId);
        }

        setFullyOutOfStockFulfillmentState(variantId, warehouseStatus) {
            this.setOnlineFulfillmentVisible(true);
            this.setOnlineFulfillmentTabsVisible(true);
            this.showBackInStockPanel();
            this.toggleHide(this.inStoreOnlyBannerElement);
            this.inStoreOnlyBannerElement?.setAttribute('aria-hidden', 'true');

            this.updateDeliveryTabState(warehouseStatus);
            this.updateClickCollectTabState(false);

            if (this.deliveryTabElement) {
                this.deliveryTabElement.disabled = true;
                this.deliveryTabElement.setAttribute('aria-disabled', 'true');
            }

            if (this.clickCollectTabElement) {
                this.toggleShow(this.clickCollectTabElement);
            }

            this.activeTab = 'delivery';
            this.tabElements.forEach((tabEl) => {
                const isActive = tabEl.dataset.tab === 'delivery';
                tabEl.classList.toggle('stock-display__tab--active', isActive);
                tabEl.setAttribute('aria-selected', isActive ? 'true' : 'false');
            });

            this.hidePanelLayer(this.deliveryPanelElement);
            this.hidePanelLayer(this.clickCollectPanelContainer);
            this.toggleHide(this.panelAreaElement);
        }

        setOnlineFulfillmentVisible(isVisible) {
            if (!this.fulfillmentElement) return;

            if (isVisible) {
                this.toggleShow(this.fulfillmentElement);
                this.fulfillmentElement.setAttribute('aria-hidden', 'false');
            } else {
                this.toggleHide(this.fulfillmentElement);
                this.fulfillmentElement.setAttribute('aria-hidden', 'true');
            }
        }

        setOnlineFulfillmentTabsVisible(isVisible) {
            if (!this.tabsElement) return;

            if (isVisible) {
                this.toggleShow(this.tabsElement);
                this.tabsElement.setAttribute('aria-hidden', 'false');
            } else {
                this.toggleHide(this.tabsElement);
                this.tabsElement.setAttribute('aria-hidden', 'true');
            }
        }

        updateFulfillmentVisibility(variantId, warehouseStatus) {
            const deliveryAvailable = this.isDeliveryAvailable(warehouseStatus);
            const clickCollectAvailable = this.hasClickCollectAvailableAnywhere(variantId);
            const inStoreOnlyWithRetail = this.isAvailableInStoreOnly(variantId, warehouseStatus);
            const onlineFulfillmentUnavailable = this.isInStoreOnlyMode(variantId, warehouseStatus);

            this.ensureComponentVisible();
            this.classList.toggle('stock-display--in-store-only', inStoreOnlyWithRetail);

            if (onlineFulfillmentUnavailable) {
                this.toggleHide(this.inStoreOnlyBannerElement);
                this.inStoreOnlyBannerElement?.setAttribute('aria-hidden', 'true');

                if (inStoreOnlyWithRetail) {
                    this.setOnlineFulfillmentVisible(false);
                    this.hideBackInStockPanel();
                    this.showInStoreOnlyExperience(variantId, warehouseStatus);
                } else {
                    this.classList.remove('stock-display--in-store-only');
                    this.hideInStoreRetailExperience();
                    this.setFullyOutOfStockFulfillmentState(variantId, warehouseStatus);
                }

                this.updateBackInStockForm(variantId, warehouseStatus);
                this.reCalculateAccordionHeight();
                return;
            }

            this.classList.remove('stock-display--in-store-only');
            this.hideBackInStockPanel();
            this.setOnlineFulfillmentVisible(true);
            this.setOnlineFulfillmentTabsVisible(true);
            this.toggleShow(this.panelAreaElement);
            this.toggleHide(this.inStoreOnlyBannerElement);
            this.inStoreOnlyBannerElement?.setAttribute('aria-hidden', 'true');

            if (this.clickCollectTabElement) {
                this.toggleShow(this.clickCollectTabElement);
                this.updateClickCollectTabState(clickCollectAvailable);
            }

            this.updateBackInStockForm(variantId, warehouseStatus);

            if (!this.initialDeliveryStateSet) {
                this.initialDeliveryStateSet = true;

                if (!deliveryAvailable && clickCollectAvailable) {
                    this.switchToTab('click-collect');
                } else {
                    this.switchToTab('delivery');
                }
            }

            this.reCalculateAccordionHeight();
        }
        
        async fetchProductAndLocationData(productId) {
            const url = `/apps/datajet/task/${this.stockDisplayQueryId}`;
            const payload = { productId: String(productId) };

            try {
                const response = await fetch(url, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(payload),
                });

                const responseJson = await response.json();

                if (response.ok && responseJson?.data?.product && responseJson?.data?.locations?.edges?.length) {
                    return responseJson.data;
                }

                console.error('Invalid Datajet response structure:', responseJson);
                return {};
            } catch (error) {
                console.error('Datajet fetch error:', error);
                return {};
            }
        }

        async getVariantAvailabilityByLocationId(variantId, locationId) {
            await this.loadProductAvailability(this.currentProductId);
            const variantData = this.getVariantInventory(variantId);
            const locationKey = locationId
                ? this.normalizeLocationGid(locationId)
                : '';
            
            if (!variantData) {
                return {
                    storeStockStatus: 'out-of-stock',
                    warehouseStockStatus: 'out-of-stock',
                    clickCollectStatus: 'unavailable',
                };
            }
            
            const onlineStoreLocation = Object.values(variantData.locations || {}).find((loc) => (
                loc.isWarehouse === true
            ));
            
            const storeLocationData = locationKey
                ? this.getLocationInventory(variantData, locationKey)
                : null;

            const getWarehouseStatus = (warehouseLocation) => {
                if (!warehouseLocation) return 'out-of-stock';
                const canShip = warehouseLocation.warehouseEnable
                    && (warehouseLocation.warehouseAvailable ?? 0) > 0;
                return canShip ? 'in-stock' : 'out-of-stock';
            };
            
            if (!storeLocationData) {
                return {
                    storeStockStatus: '',
                    warehouseStockStatus: getWarehouseStatus(onlineStoreLocation),
                    clickCollectStatus: 'unavailable'
                };
            }

            return {
                ...storeLocationData,
                warehouseStockStatus: getWarehouseStatus(onlineStoreLocation)
            };
        }
        
        
        async loadProductAvailability(productId) {
            if (this.productAvailabilityCache) return this.productAvailabilityCache;

            if (!this.productAvailabilityPromise) {
                this.productAvailabilityPromise = this.buildProductAvailabilityFromDatajet(productId)
                    .finally(() => {
                        this.productAvailabilityPromise = null;
                    });
            }

            return this.productAvailabilityPromise;
        }

        async buildProductAvailabilityFromDatajet(productId) {
            const response = await this.fetchProductAndLocationData(productId);
            const { product, locations } = response;
            
            if (!product || !locations?.edges?.length) {
                console.error('Stock display: missing product or location data from Datajet');
                return {};
            }

            this.style.removeProperty('display');
            
            product.variants.edges.forEach(({ node: variant }) => {
                const variantId = this.normalizeVariantGid(variant.id);
                const hideStockDisplay = variant.hideStockDisplay?.value ?? null;
                const locationsMap = {};
                let totalWarehouseAvailable = 0;
                let totalStoreAvailable = 0;
                let variantAvailableForSale = variant.availableForSale;
                
                variant.inventoryItem.inventoryLevels.edges.forEach(({ node: level }) => {
                    const loc = level.location;
                    const locationId = this.normalizeLocationGid(loc.id);
                    const availableQuantity = level.quantities.find(q => q.name === 'available')?.quantity ?? 0;
                    
                    if (!locationsMap[locationId]) {
                        locationsMap[locationId] = {
                            name: loc.name,
                            frontEndName: loc.storeFrontendName?.value || loc.name,
                            storeHidden: loc.storeHidden?.value === 'true',
                            enableForPickup: loc.enableForPickup?.value === 'true',
                            storeEnable: loc.storeStockAvailability?.value === 'true',
                            warehouseEnable: loc.warehouseStockAvailability?.value === 'true',
                            inStockThreshold: parseInt(loc.inStockThreshold?.value) ?? 0,
                            outOfStockThreshold: parseInt(loc.outOfStockThreshold?.value) ?? 0,
                            storeAvailable: 0,
                            warehouseAvailable: 0,
                            totalAvailable: 0,
                            storeStockStatus: null,
                            warehouseStockStatus: 'out-of-stock',
                            isWarehouse: loc.isWarehouse?.value === 'true'
                        };
                    }
                    
                    const store = locationsMap[locationId];
                    store.totalAvailable += availableQuantity;
                    
                    if (store.storeEnable) {
                        store.storeAvailable += availableQuantity;
                        totalStoreAvailable += availableQuantity;
                    }
                    
                    if (store.warehouseEnable) {
                        store.warehouseAvailable += availableQuantity;
                        totalWarehouseAvailable += availableQuantity;
                    }

                    store.storeStockStatus = store.storeAvailable > 0 ? 'available' : 'unavailable';
                    store.warehouseStockStatus = store.warehouseAvailable > 0 ? 'available' : 'unavailable';
                    store.clickCollectStatus =
                        (this.blockClickCollect || !store.storeEnable || !store.enableForPickup || store.totalAvailable <= 0) ? 'unavailable' : 'available';
                    if (hideStockDisplay === 'true') {
                        store.storeStockStatus = 'unavailable';
                    }
                });
                
                locations.edges.forEach(({ node }) => {
                    const locationId = this.normalizeLocationGid(node.id);
                    if (!locationsMap[locationId]) {
                        locationsMap[locationId] = {
                            name: node.name,
                            frontEndName: node.storeFrontendName?.value || node.name,
                            storeHidden: node.storeHidden?.value === 'true',
                            enableForPickup: node.enableForPickup?.value === 'true',
                            storeEnable: node.storeStockAvailability?.value === 'true',
                            warehouseEnable: node.warehouseStockAvailability?.value === 'true',
                            inStockThreshold: parseInt(node.inStockThreshold?.value) ?? 0,
                            outOfStockThreshold: parseInt(node.outOfStockThreshold?.value) ?? 0,
                            storeAvailable: 0,
                            warehouseAvailable: 0,
                            totalAvailable: 0,
                            storeStockStatus: 'out-of-stock',
                            warehouseStockStatus: 'out-of-stock',
                            isWarehouse: node.isWarehouse?.value === 'true',
                              clickCollectStatus: 'unavailable'
                        };
                    }
                });
                
                this.inventoryByVariantId[variantId] = {
                    hideStockDisplay,
                    totalStoreAvailable,
                    totalWarehouseAvailable,
                    locations: locationsMap
                };
            });
            
            this.locationsList = locations.edges.map(edge => edge.node);
            this.datajetLocations = locations;
            this.productAvailabilityCache = this.inventoryByVariantId;
            return this.productAvailabilityCache;
        }
        
        formatStoreAddress(address) {
            if (!address) return '';

            if (address.formatted) {
                return Array.isArray(address.formatted)
                    ? address.formatted.filter(Boolean).join(', ')
                    : address.formatted;
            }

            return [
                address.address1,
                address.address2,
                address.city,
                address.province,
                address.zip,
                address.country,
            ].filter(Boolean).join(', ');
        }

        getLocationDisplayName(location) {
            if (!location) return '';
            return location.storeFrontendName?.value || location.name || '';
        }

        getLocationSubtitle(location, displayName) {
            if (!location) return '';

            const addressLine = this.formatStoreAddress(location.address);
            const hasStreetAddress = Boolean(
                location.address?.address1 ||
                location.address?.address2 ||
                location.address?.city
            );

            if (hasStreetAddress && addressLine) {
                return addressLine;
            }

            if (location.name && location.name !== displayName) {
                return location.name;
            }

            return addressLine;
        }

        isPickupEnabled(location) {
            return location?.enableForPickup?.value === 'true';
        }

        normalizeVariantGid(variantId) {
            if (!variantId) return '';
            const id = String(variantId);
            if (id.startsWith('gid://shopify/ProductVariant/')) {
                return id;
            }
            return `gid://shopify/ProductVariant/${id}`;
        }

        normalizeLocationGid(locationId) {
            if (!locationId) return '';
            const id = String(locationId).replace('gid://shopify/Location/', '');
            return `gid://shopify/Location/${id}`;
        }

        findLocationById(locationId) {
            const normalizedId = this.normalizeLocationGid(locationId);
            return (this.locationsList || []).find((location) => (
                this.normalizeLocationGid(location.id) === normalizedId
            ));
        }

        getLocationInventory(variantInventory, locationId) {
            if (!variantInventory?.locations || !locationId) return null;

            const normalizedId = this.normalizeLocationGid(locationId);
            if (variantInventory.locations[normalizedId]) {
                return variantInventory.locations[normalizedId];
            }

            const numericId = normalizedId.replace('gid://shopify/Location/', '');
            const matchedEntry = Object.entries(variantInventory.locations).find(([key]) => (
                key.endsWith(`/${numericId}`)
            ));

            return matchedEntry?.[1] ?? null;
        }

        isRetailLocation(location) {
            if (!location) return false;
            if (location.isWarehouse?.value === 'true') return false;
            if (location.storeHidden?.value === 'true') return false;
            return true;
        }

        isStoreEligibleForModal(location) {
            if (!location) return false;
            if (location.isWarehouse?.value === 'true') return false;
            if (location.storeHidden?.value === 'true') return false;
            if (location.storeStockAvailability?.value !== 'true') return false;
            if (!this.isPickupEnabled(location)) return false;
            return true;
        }

        isStoreEligibleForInStorePanel(location) {
            return this.isRetailLocation(location);
        }

        getVariantInventory(variantId) {
            const normalizedId = this.normalizeVariantGid(variantId);

            if (this.inventoryByVariantId[normalizedId]) {
                return this.inventoryByVariantId[normalizedId];
            }

            const numericId = String(variantId).replace(/^gid:\/\/shopify\/ProductVariant\//, '');
            const matchedEntry = Object.entries(this.inventoryByVariantId).find(([key]) => (
                key.endsWith(`/${numericId}`)
            ));

            return matchedEntry?.[1];
        }

        isRetailInventoryLocation(inventory, location) {
            if (!inventory || inventory.isWarehouse) return false;
            if (inventory.storeHidden) return false;
            if (location) return this.isRetailLocation(location);
            return true;
        }

        getRetailStoreEntries(variantId) {
            const variantInventory = this.getVariantInventory(variantId);
            if (!variantInventory?.locations) return [];

            const entries = [];
            const seen = new Set();

            const addEntry = (location, inventory, locationId) => {
                if (!inventory || !locationId || seen.has(locationId)) return;
                if (!this.isRetailInventoryLocation(inventory, location)) return;

                seen.add(locationId);
                entries.push({ location, inventory, locationId });
            };

            (this.locationsList || []).forEach((location) => {
                const locationId = this.normalizeLocationGid(location.id);
                addEntry(location, this.getLocationInventory(variantInventory, locationId), locationId);
            });

            Object.entries(variantInventory.locations).forEach(([locationId, inventory]) => {
                const location = this.findLocationById(locationId);
                addEntry(location, inventory, this.normalizeLocationGid(locationId));
            });

            return entries;
        }

        getLocationQuantityForInStore(inventory) {
            if (!inventory) return 0;

            if (inventory.storeEnable) {
                return Math.max(inventory.storeAvailable ?? 0, inventory.totalAvailable ?? 0);
            }

            return inventory.totalAvailable ?? 0;
        }

        hasRetailStoreStock(variantId) {
            const variantInventory = this.getVariantInventory(variantId);
            if (!variantInventory?.locations) return false;

            if ((variantInventory.totalStoreAvailable ?? 0) > 0) {
                return true;
            }

            const hasStockInRetailEntries = this.getRetailStoreEntries(variantId).some(
                ({ inventory }) => this.getLocationQuantityForInStore(inventory) > 0
            );

            if (hasStockInRetailEntries) {
                return true;
            }

            return Object.values(variantInventory.locations).some((inventory) => {
                if (!inventory || inventory.isWarehouse || inventory.storeHidden) return false;
                return (inventory.totalAvailable ?? 0) > 0;
            });
        }

        hasOnlyWarehouseStock(variantId) {
            const variantInventory = this.getVariantInventory(variantId);
            if (!variantInventory?.locations) return false;

            let warehouseStock = 0;
            let retailStock = 0;

            Object.values(variantInventory.locations).forEach((inventory) => {
                const quantity = this.getLocationQuantityForInStore(inventory);

                if (inventory.isWarehouse) {
                    warehouseStock += inventory.totalAvailable ?? 0;
                    return;
                }

                if (this.isRetailInventoryLocation(inventory)) {
                    retailStock += quantity;
                }
            });

            return warehouseStock > 0 && retailStock === 0;
        }

        shouldShowInStoreButton(variantId, warehouseStatus) {
            if (this.hasOnlyWarehouseStock(variantId)) return false;
            if (!this.hasRetailStoreStock(variantId)) return false;
            if (this.isInStoreOnlyMode(variantId, warehouseStatus)) return false;
            return true;
        }

        getInStorePanelStores(variantId) {
            return this.getRetailStoreEntries(variantId)
                .map(({ location, inventory, locationId }) => {
                    const quantity = this.getLocationQuantityForInStore(inventory);
                    const displayName = location
                        ? this.getLocationDisplayName(location)
                        : (inventory.frontEndName || inventory.name || 'Store');

                    return {
                        location,
                        locationId,
                        displayName,
                        subtitle: location
                            ? this.getLocationSubtitle(location, displayName)
                            : '',
                        isInStock: quantity > 0,
                        directionsUrl: location ? this.getDirectionsUrl(location) : '',
                    };
                })
                .sort((a, b) => {
                    if (a.isInStock !== b.isInStock) {
                        return a.isInStock ? -1 : 1;
                    }
                    return a.displayName.localeCompare(b.displayName);
                });
        }

        getDirectionsUrl(location) {
            if (!location) return '';

            const displayName = this.getLocationDisplayName(location);
            const address = this.formatStoreAddress(location.address);
            const query = [displayName, address].filter(Boolean).join(', ');

            return query
                ? `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(query)}`
                : '';
        }

        updateInStorePanelCopy(variantId, warehouseStatus) {
            if (!this.inStoreTitleElement || !this.inStoreDescriptionElement) return;

            const warehouseAvailable = this.normalizeStatus(warehouseStatus) === 'available';
            const variantInventory = this.getVariantInventory(variantId);
            const hasClickCollectAvailable = variantInventory?.locations
                ? Object.values(variantInventory.locations).some((loc) =>
                    !loc.isWarehouse && loc.clickCollectStatus === 'available'
                )
                : false;

            if (!warehouseAvailable && !hasClickCollectAvailable) {
                this.inStoreTitleElement.textContent = 'Available in store only';
                this.inStoreDescriptionElement.textContent =
                    'Online delivery and Click & Collect are currently unavailable for this item. Visit a store to purchase.';
            } else {
                this.inStoreTitleElement.textContent = 'Also available in store';
                this.inStoreDescriptionElement.textContent =
                    'Visit one of the following stores to purchase this item in person.';
            }
        }

        renderInStoreList(variantId) {
            if (!this.inStoreListElement) return;

            const stores = this.getInStorePanelStores(variantId);
            this.inStoreListElement.innerHTML = '';

            stores.forEach((store) => {
                const item = document.createElement('div');
                item.className = 'stock-display__in-store-item';
                item.setAttribute('role', 'listitem');

                const main = document.createElement('div');
                main.className = 'stock-display__in-store-item-main';

                const icon = this.createInStoreStatusIcon(store.isInStock);
                main.appendChild(icon);

                const text = document.createElement('div');
                text.className = 'stock-display__in-store-item-text';

                const name = document.createElement('p');
                name.className = 'stock-display__in-store-item-name';
                name.textContent = store.displayName;
                text.appendChild(name);

                const status = document.createElement('p');
                status.className = `stock-display__in-store-item-status ${store.isInStock ? 'stock-display__in-store-item-status--in-stock' : 'stock-display__in-store-item-status--out-of-stock'}`;
                status.textContent = store.isInStock ? 'In stock' : 'Out of stock';
                text.appendChild(status);

                main.appendChild(text);
                item.appendChild(main);

                if (store.directionsUrl) {
                    const directions = document.createElement('a');
                    directions.className = 'stock-display__in-store-directions';
                    directions.href = store.directionsUrl;
                    directions.target = '_blank';
                    directions.rel = 'noopener noreferrer';
                    directions.textContent = 'Get directions';
                    item.appendChild(directions);
                }

                this.inStoreListElement.appendChild(item);
            });
        }

        createInStoreStatusIcon(isInStock) {
            const selector = isInStock
                ? '.stock-display__panel-icon-state--in-stock'
                : '.stock-display__panel-icon-state--out-of-stock';
            const template = this.querySelector(selector);
            const icon = template ? template.cloneNode(true) : document.createElement('span');

            icon.classList.add('stock-display__in-store-item-icon');
            if (isInStock) {
                icon.classList.add('stock-display__in-store-item-icon--in-stock');
            } else {
                icon.classList.add('stock-display__in-store-item-icon--out-of-stock');
            }

            return icon;
        }

        closeInStorePanel() {
            this.inStorePanelOpen = false;
            this.toggleHide(this.inStorePanelElement);
            this.inStorePanelElement?.setAttribute('aria-hidden', 'true');
            this.toggleShow(this.checkAvailabilityButton);
            this.checkAvailabilityButton?.setAttribute('aria-expanded', 'false');
        }

        hideInStoreRetailExperience() {
            this.inStorePanelOpen = false;
            this.toggleHide(this.inStorePanelElement);
            this.inStorePanelElement?.setAttribute('aria-hidden', 'true');
            this.toggleHide(this.checkAvailabilityButton);
            this.toggleHide(this.storeButtonChevronElement);
            this.storeButtonChevronElement?.setAttribute('aria-hidden', 'true');
            this.toggleHide(this.storeCheckElement);
        }

        showInStoreOnlyExperience(variantId, warehouseStatus) {
            if (!this.storeCheckElement || !this.inStorePanelElement) return;

            this.toggleShow(this.storeCheckElement);
            this.updateInStorePanelCopy(variantId, warehouseStatus);
            this.closeInStoreAvailabilityModal();
            this.inStorePanelOpen = true;
            this.renderInStoreList(variantId);
            this.toggleHide(this.checkAvailabilityButton);
            this.toggleHide(this.storeButtonChevronElement);
            this.storeButtonChevronElement?.setAttribute('aria-hidden', 'true');
            this.toggleShow(this.inStorePanelElement);
            this.inStorePanelElement.setAttribute('aria-hidden', 'false');
        }

        openInStorePanel() {
            if (!this.inStorePanelElement || !this.checkAvailabilityButton) return;

            this.inStorePanelOpen = true;
            this.renderInStoreList(this.currentVariantId);
            this.toggleHide(this.checkAvailabilityButton);
            this.toggleShow(this.inStorePanelElement);
            this.inStorePanelElement?.setAttribute('aria-hidden', 'false');
            this.checkAvailabilityButton.setAttribute('aria-expanded', 'true');
        }

        renderInStoreAvailabilityModalList() {
            if (!this.inStoreAvailabilityModalListElement) return;

            const stores = this.getInStorePanelStores(this.currentVariantId);
            const listElement = this.inStoreAvailabilityModalListElement;
            listElement.innerHTML = '';

            if (!stores.length) {
                listElement.innerHTML = '<p class="stock-display__availability-modal-empty">No stores available.</p>';
                return;
            }

            stores.forEach((store) => {
                const card = document.createElement('div');
                card.className = 'stock-display__availability-modal-card';
                card.setAttribute('role', 'listitem');

                const name = document.createElement('p');
                name.className = 'stock-display__availability-modal-card-name';
                name.textContent = store.displayName;
                card.appendChild(name);

                if (store.subtitle) {
                    const address = document.createElement('p');
                    address.className = 'stock-display__availability-modal-card-address';
                    address.textContent = store.subtitle;
                    card.appendChild(address);
                }

                const status = document.createElement('p');
                status.className = `stock-display__availability-modal-card-status ${store.isInStock ? 'stock-display__availability-modal-card-status--in-stock' : 'stock-display__availability-modal-card-status--out-of-stock'}`;
                status.textContent = store.isInStock ? 'In stock' : 'Out of stock';
                card.appendChild(status);

                listElement.appendChild(card);
            });
        }

        openDrawerModal(modalElement, onOpen) {
            if (!modalElement || !modalElement.classList.contains('hide')) return;

            modalElement.classList.remove('hide');
            document.body.classList.add('popup-open');

            window.requestAnimationFrame(() => {
                window.requestAnimationFrame(() => {
                    modalElement.classList.add('stock-display__drawer-modal--open');
                });
            });

            onOpen?.();
        }

        closeDrawerModal(modalElement, onClose) {
            if (!modalElement || modalElement.classList.contains('hide') || modalElement.dataset.closing === 'true') {
                return;
            }

            modalElement.dataset.closing = 'true';
            modalElement.classList.remove('stock-display__drawer-modal--open');

            const panel = modalElement.querySelector('[class*="modal-panel"]');
            let hasFinished = false;

            const finishClose = () => {
                if (hasFinished) return;
                hasFinished = true;

                if (panel) {
                    panel.removeEventListener('transitionend', handleTransitionEnd);
                }

                modalElement.classList.add('hide');
                delete modalElement.dataset.closing;
                document.body.classList.remove('popup-open');
                onClose?.();
            };

            const handleTransitionEnd = (event) => {
                if (event.target !== panel || event.propertyName !== 'transform') return;
                finishClose();
            };

            if (panel) {
                panel.addEventListener('transitionend', handleTransitionEnd);
            }

            window.setTimeout(finishClose, DRAWER_MODAL_TRANSITION_MS + 50);
        }

        isDrawerModalVisible(modalElement) {
            return Boolean(modalElement && !modalElement.classList.contains('hide'));
        }

        openInStoreAvailabilityModal(triggerElement) {
            if (!this.inStoreAvailabilityModalElement) return;

            this.inStoreAvailabilityModalTriggerElement = triggerElement || null;
            this.renderInStoreAvailabilityModalList();
            this.openDrawerModal(this.inStoreAvailabilityModalElement, () => {
                this.checkAvailabilityButton?.setAttribute('aria-expanded', 'true');
                this.inStoreAvailabilityModalCloseButton?.focus();
            });
        }

        closeInStoreAvailabilityModal() {
            if (!this.inStoreAvailabilityModalElement) return;

            this.closeDrawerModal(this.inStoreAvailabilityModalElement, () => {
                this.checkAvailabilityButton?.setAttribute('aria-expanded', 'false');

                if (this.inStoreAvailabilityModalTriggerElement) {
                    this.inStoreAvailabilityModalTriggerElement.focus();
                    this.inStoreAvailabilityModalTriggerElement = null;
                }
            });
        }

        inStoreAvailabilityModalEvent() {
            this.inStoreAvailabilityModalCloseButton?.addEventListener('click', () => {
                this.closeInStoreAvailabilityModal();
            });

            this.inStoreAvailabilityModalBackdropElements?.forEach((element) => {
                element.addEventListener('click', () => this.closeInStoreAvailabilityModal());
            });

            document.addEventListener('keydown', (event) => {
                if (
                    event.key === 'Escape'
                    && this.isDrawerModalVisible(this.inStoreAvailabilityModalElement)
                ) {
                    this.closeInStoreAvailabilityModal();
                }
            });
        }

        updateInStoreAvailability(variantId, warehouseStatus) {
            const hasRetailStock = this.hasRetailStoreStock(variantId);
            const inStoreOnly = this.isInStoreOnlyMode(variantId, warehouseStatus);

            if (inStoreOnly && hasRetailStock) {
                this.showInStoreOnlyExperience(variantId, warehouseStatus);
                return;
            }

            if (!hasRetailStock) {
                this.closeInStoreAvailabilityModal();
                this.closeInStorePanel();
                this.hideInStoreRetailExperience();
                return;
            }

            this.toggleShow(this.storeCheckElement);
            this.updateInStorePanelCopy(variantId, warehouseStatus);

            this.closeInStorePanel();

            this.toggleShow(this.checkAvailabilityButton);
            this.toggleShow(this.storeButtonChevronElement);
            this.storeButtonChevronElement?.setAttribute('aria-hidden', 'false');
            this.toggleHide(this.inStorePanelElement);
            this.inStorePanelElement?.setAttribute('aria-hidden', 'true');
            this.checkAvailabilityButton?.setAttribute('aria-expanded', 'false');
        }

        storeCheckEvent() {
            this.checkAvailabilityButton?.addEventListener('click', (event) => {
                event.preventDefault();

                if (!this.shouldShowInStoreButton(this.currentVariantId, this.currentWarehouseStatus)) {
                    return;
                }

                this.openInStoreAvailabilityModal(event.currentTarget);
            });
        }

        mapLocationToStoreChoice(location, inventory, currentLocationId) {
            const locationId = location.id.replace('gid://shopify/Location/', '');
            const displayName = this.getLocationDisplayName(location);

            return {
                value: displayName,
                label: displayName,
                customProperties: {
                    id: locationId,
                    province: location.address?.province || '',
                    subtitle: this.getLocationSubtitle(location, displayName),
                    clickCollectStatus: inventory?.clickCollectStatus || 'unavailable',
                    storeStockStatus: inventory?.storeStockStatus || 'unavailable',
                },
                selected: locationId === currentLocationId,
            };
        }

        isClickCollectAvailable(status) {
            return status === 'in-stock' || status === 'available' || status === 'low-in-stock';
        }

        isClickCollectAvailableForLocation(data) {
            if (!data) return false;

            if (this.blockClickCollect) return false;

            const storeAvailable = this.normalizeStatus(data.storeStockStatus) === 'available';
            const clickCollectAvailable = this.isClickCollectAvailable(data.clickCollectStatus);

            return storeAvailable && clickCollectAvailable;
        }

        buildStoreList(variantId) {
            const variantInventory = this.getVariantInventory(variantId);
            const locationsMap = variantInventory?.locations || {};
            const currentLocationId = this.currentLocationId || this.currentStoreCookie?.dataId || '';

            if (!this.locationsList?.length) {
                this.storeChoicesList = [];
                this.renderStoreModalList();
                return;
            }

            this.storeChoicesList = this.locationsList
                .filter((location) => this.isStoreEligibleForModal(location))
                .map((location) => this.mapLocationToStoreChoice(
                    location,
                    this.getLocationInventory(variantInventory, location.id),
                    currentLocationId
                ))
                .sort((a, b) => {
                    const aAvailable = this.isClickCollectAvailableForLocation({
                        clickCollectStatus: a.customProperties.clickCollectStatus,
                        storeStockStatus: a.customProperties.storeStockStatus,
                    });
                    const bAvailable = this.isClickCollectAvailableForLocation({
                        clickCollectStatus: b.customProperties.clickCollectStatus,
                        storeStockStatus: b.customProperties.storeStockStatus,
                    });

                    if (aAvailable !== bAvailable) {
                        return aAvailable ? -1 : 1;
                    }

                    return a.label.localeCompare(b.label);
                });

            this.renderStoreModalList();
        }

        renderStoreModalList({ isLoading = false } = {}) {
            if (!this.storeModalListElement) return;

            const listElement = this.storeModalListElement;
            listElement.innerHTML = '';

            if (isLoading) {
                listElement.innerHTML = '<p class="stock-display__store-modal-empty">Loading stores...</p>';
                return;
            }

            if (!this.storeChoicesList.length) {
                listElement.innerHTML = '<p class="stock-display__store-modal-empty">No stores available for click &amp; collect.</p>';
                return;
            }

            this.storeChoicesList.forEach((storeChoice) => {
                const isAvailable = this.isClickCollectAvailableForLocation({
                    clickCollectStatus: storeChoice.customProperties.clickCollectStatus,
                    storeStockStatus: storeChoice.customProperties.storeStockStatus,
                });
                const isSelected = storeChoice.customProperties.id === this.pendingModalStoreId;
                const card = document.createElement('button');
                card.type = 'button';
                card.className = 'stock-display__store-modal-card';
                card.setAttribute('role', 'option');
                card.setAttribute('aria-selected', isSelected ? 'true' : 'false');

                if (!isAvailable) {
                    card.classList.add('stock-display__store-modal-card--unavailable');
                    card.disabled = true;
                } else if (isSelected) {
                    card.classList.add('stock-display__store-modal-card--selected');
                }

                const name = document.createElement('p');
                name.className = 'stock-display__store-modal-card-name';
                name.textContent = storeChoice.label;
                card.appendChild(name);

                const subtitle = storeChoice.customProperties.subtitle;
                if (subtitle) {
                    const address = document.createElement('p');
                    address.className = 'stock-display__store-modal-card-address';
                    address.textContent = subtitle;
                    card.appendChild(address);
                }

                const status = document.createElement('div');
                status.className = 'stock-display__store-modal-card-status';

                const badge = document.createElement('span');
                badge.className = `stock-display__store-modal-card-badge ${isAvailable ? 'stock-display__store-modal-card-badge--success' : 'stock-display__store-modal-card-badge--error'}`;
                badge.textContent = isAvailable ? 'In stock' : 'Out of stock';
                status.appendChild(badge);

                if (isAvailable) {
                    const divider = document.createElement('span');
                    divider.className = 'stock-display__store-modal-card-divider';
                    divider.setAttribute('aria-hidden', 'true');
                    divider.textContent = '·';

                    const ready = document.createElement('span');
                    ready.className = 'stock-display__store-modal-card-ready';
                    ready.textContent = 'Ready in 2 hours';

                    status.appendChild(divider);
                    status.appendChild(ready);
                    card.addEventListener('click', () => this.selectPendingStore(storeChoice));
                }

                card.appendChild(status);
                listElement.appendChild(card);
            });
        }

        selectPendingStore(storeChoice) {
            if (!storeChoice?.customProperties?.id) return;

            this.pendingModalStoreId = storeChoice.customProperties.id;
            this.renderStoreModalList();
            this.updateStoreModalFooter();
        }

        getPendingStoreChoice() {
            return this.storeChoicesList.find(
                (storeChoice) => storeChoice.customProperties.id === this.pendingModalStoreId
            );
        }

        async fetchCartPickupStore() {
            this.cartPickupStoreId = '';
            this.cartPickupStoreName = '';

            try {
                const response = await fetch('/cart.json');
                const cart = await response.json();

                if (!cart?.item_count) return;

                this.cartPickupStoreId = cart.attributes?._pickup_store_id || '';
                this.cartPickupStoreName = cart.attributes?._pickup_store_name || '';
            } catch (error) {
                console.error('Failed to fetch cart pickup store:', error);
            }
        }

        updateStoreModalFooter() {
            const hasPendingSelection = Boolean(this.pendingModalStoreId);
            const pendingChoice = this.getPendingStoreChoice();
            const showStoreChangeWarning = hasPendingSelection
                && Boolean(this.cartPickupStoreId)
                && this.pendingModalStoreId !== this.cartPickupStoreId;

            this.toggleHide(this.storeModalFooterHintElement);
            this.toggleHide(this.storeModalFooterSelectedElement);
            this.toggleHide(this.storeModalFooterWarningElement);
            this.toggleHide(this.storeModalConfirmButton);

            if (!hasPendingSelection) {
                this.toggleShow(this.storeModalFooterHintElement);
                this.storeModalFooterHintElement?.setAttribute('aria-hidden', 'false');
                this.storeModalFooterSelectedElement?.setAttribute('aria-hidden', 'true');
                this.storeModalFooterWarningElement?.setAttribute('aria-hidden', 'true');
                this.storeModalConfirmButton?.setAttribute('aria-hidden', 'true');
                return;
            }

            this.storeModalFooterHintElement?.setAttribute('aria-hidden', 'true');

            if (showStoreChangeWarning) {
                this.toggleShow(this.storeModalFooterWarningElement);
                this.storeModalFooterWarningElement?.setAttribute('aria-hidden', 'false');
                this.storeModalFooterSelectedElement?.setAttribute('aria-hidden', 'true');

                if (this.storeModalWarningDetailElement) {
                    const cartStoreName = this.cartPickupStoreName || 'another store';
                    this.storeModalWarningDetailElement.textContent = `You have click & collect items in your cart from ${cartStoreName}. Switching to another store will update those items.`;
                }
            } else {
                this.toggleShow(this.storeModalFooterSelectedElement);
                this.storeModalFooterSelectedElement?.setAttribute('aria-hidden', 'false');
                this.storeModalFooterWarningElement?.setAttribute('aria-hidden', 'true');

                if (this.storeModalCollectingNameElement) {
                    this.storeModalCollectingNameElement.textContent = pendingChoice?.label || '';
                }
            }

            this.toggleShow(this.storeModalConfirmButton);
            this.storeModalConfirmButton?.setAttribute('aria-hidden', 'false');
        }

        confirmPendingStore() {
            const pendingChoice = this.getPendingStoreChoice();
            if (!pendingChoice) return;

            this.selectStore(pendingChoice);
        }

        initializeStoreModalSelection() {
            const currentId = this.currentLocationId || this.currentStoreCookie?.dataId || '';
            let pendingId = '';

            if (currentId) {
                const currentChoice = this.storeChoicesList.find(
                    (storeChoice) => storeChoice.customProperties.id === currentId
                );

                if (currentChoice && this.isClickCollectAvailableForLocation({
                    clickCollectStatus: currentChoice.customProperties.clickCollectStatus,
                    storeStockStatus: currentChoice.customProperties.storeStockStatus,
                })) {
                    pendingId = currentId;
                }
            }

            this.pendingModalStoreId = pendingId;
            this.renderStoreModalList();
            this.updateStoreModalFooter();
        }

        selectStore(storeChoice) {
            if (!storeChoice?.customProperties) return;

            const storeData = {
                name: storeChoice.value,
                dataId: storeChoice.customProperties.id,
                province: storeChoice.customProperties.province,
                storeStockAvailability: storeChoice.customProperties.storeStockStatus,
            };

            this.closeStoreModal();
            this.pendingModalStoreId = '';
            this.setCookie('currentStore', storeData, 30);
            this.currentStoreCookie = this.getCookie('currentStore');
            this.setCurrentStore();
            this.setStockAvailability(this.currentVariantId, storeData.dataId);
            this.buildStoreList(this.currentVariantId);

            document.dispatchEvent(new CustomEvent('storeLocationChanged', {
                detail: storeData,
            }));
        }

        openStoreModal(triggerElement) {
            if (!this.storeModalElement) return;

            this.storeModalTriggerElement = triggerElement || null;

            const initModalContent = () => {
                this.buildStoreList(this.currentVariantId);
                this.initializeStoreModalSelection();
                this.storeModalCloseButton?.focus();
            };

            const cartPromise = this.fetchCartPickupStore();

            if (this.productAvailabilityCache) {
                cartPromise.then(() => {
                    this.openDrawerModal(this.storeModalElement, initModalContent);
                });
                return;
            }

            this.pendingModalStoreId = '';
            this.renderStoreModalList({ isLoading: true });
            this.updateStoreModalFooter();
            this.openDrawerModal(this.storeModalElement, () => {
                this.storeModalCloseButton?.focus();
            });

            Promise.all([
                this.loadProductAvailability(this.currentProductId),
                cartPromise,
            ]).then(initModalContent);
        }

        closeStoreModal() {
            if (!this.storeModalElement) return;

            this.pendingModalStoreId = '';
            this.updateStoreModalFooter();

            this.closeDrawerModal(this.storeModalElement, () => {
                if (this.storeModalTriggerElement) {
                    this.storeModalTriggerElement.focus();
                    this.storeModalTriggerElement = null;
                }
            });
        }

        storeModalEvent() {
            this.selectStoreButton?.addEventListener('click', (event) => {
                event.preventDefault();
                this.openStoreModal(event.currentTarget);
            });

            this.changeStoreButton?.addEventListener('click', (event) => {
                event.preventDefault();
                this.openStoreModal(event.currentTarget);
            });

            this.storeModalCloseButton?.addEventListener('click', () => this.closeStoreModal());
            this.storeModalBackdropElement?.addEventListener('click', () => this.closeStoreModal());
            this.storeModalConfirmButton?.addEventListener('click', () => this.confirmPendingStore());

            document.addEventListener('keydown', (event) => {
                if (event.key === 'Escape' && this.isDrawerModalVisible(this.storeModalElement)) {
                    this.closeStoreModal();
                }
            });
        }

        async setCurrentStore() {
            if (this.currentStoreCookie) {
                const location = this.locationsList.find(loc => loc.id.replace('gid://shopify/Location/', '') === this.currentStoreCookie.dataId);

                if (!location || !this.isPickupEnabled(location)) {
                    this.setCookie('currentStore', null, -1);
                    this.currentStoreCookie = null;
                    this.setClickCollectPanelWhenNoStore();
                    this.currentLocationId = '';
                    return;
                }

                const displayName = this.getLocationDisplayName(location) || this.currentStoreCookie.name;

                await this.updateAttributeCart('_pickup_store_name', displayName);
                await this.updateAttributeCart('_pickup_store_id', this.currentStoreCookie.dataId);

                this.storeNameElement.textContent = displayName;
                this.currentLocationId = this.currentStoreCookie.dataId;
                this.setClickCollectPanelWithStore(displayName);
                if (this.hasClickCollectAvailableAnywhere(this.currentVariantId)) {
                    this.switchToTab('click-collect');
                }
            } else {
                this.setClickCollectPanelWhenNoStore();
                this.currentLocationId = '';
            }
        }

        async updateAttributeCart(key, value) {
            try {
                const response = await fetch('/cart/update.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        attributes: {
                            [key]: value || '',
                        },
                    }),
                });

                const data = await response.json();
                console.log('✅ Cart attribute updated:', data.attributes);
                return data;
            } catch (error) {
                console.error('❌ Error updating pickup store attribute:', error);
            }
        }

        setStockStatusHtml(element, status) {
            this.setPanelStatus(
                element,
                this.deliveryIconElement,
                status,
                'Free standard delivery on orders over $99.95',
                this.outOfStockText
            );
        }

        setClickCollectStatusHtml(data, storeDisplayName) {
            const isAvailable = this.isClickCollectAvailableForLocation(data);

            if (storeDisplayName && this.selectedStoreNameElement) {
                this.selectedStoreNameElement.textContent = storeDisplayName;
            }

            if (this.selectedStoreBadgeElement) {
                this.selectedStoreBadgeElement.textContent = isAvailable ? 'In stock' : 'Out of stock';
                this.selectedStoreBadgeElement.classList.toggle('stock-display__store-selected-badge--success', isAvailable);
                this.selectedStoreBadgeElement.classList.toggle('stock-display__store-selected-badge--error', !isAvailable);
            }

            if (this.selectedStoreReadyElement) {
                this.selectedStoreReadyElement.textContent = isAvailable ? 'Ready in 2 hours' : '';
            }

            if (this.storeSelectedContentElement) {
                this.storeSelectedContentElement.classList.toggle('stock-display__store-selected-content--unavailable', !isAvailable);
            }
        }

        normalizeStatus(status) {
            if (!status) return 'unavailable';
            if (status === 'in-stock' || status === 'available' || status === 'low-in-stock') {
                return 'available';
            }
            return 'unavailable';
        }

        getStoreDisplayName(locationId) {
            if (!locationId) return this.storeNameElement?.textContent || '';

            const location = this.findLocationById(locationId);

            return this.getLocationDisplayName(location) || this.storeNameElement?.textContent || '';
        }
        hasStoreSelected() {
            return !!(this.currentLocationId || this.currentStoreCookie?.dataId);
        }

        requiresStoreSelection(warehouseStatus) {
            const clickCollectAvailable = this.hasClickCollectAvailableAnywhere(this.currentVariantId);
            const deliveryAvailable = this.isDeliveryAvailable(warehouseStatus);

            if (!clickCollectAvailable || this.hasStoreSelected()) return false;
            if (!deliveryAvailable) return true;

            return this.activeTab === 'click-collect';
        }

        refreshAddToCartButton() {
            this.updateAddToCartButtonText({
                warehouseStockStatus: this.currentWarehouseStatus,
            });
        }

        updateAddToCartButtonText(data) {
            document.querySelector("#ispickupstore")?.remove();
            const warehouseStatus = this.normalizeStatus(data.warehouseStockStatus);
            const clickCollectAvailable = this.hasClickCollectAvailableAnywhere(this.currentVariantId);
            const deliveryAvailable = this.isDeliveryAvailable(warehouseStatus);
            const inStoreOnlyWithRetail = this.isAvailableInStoreOnly(this.currentVariantId, warehouseStatus);
            let buttonText = 'Add to Cart';
            let shouldDisable = false;
            const productForm = document.querySelector("[data-section-id='product'] .product-form, [data-section-type='product'] .product-form");

            if (deliveryAvailable || clickCollectAvailable) {
                if (this.requiresStoreSelection(warehouseStatus)) {
                    buttonText = 'Choose a store';
                    shouldDisable = true;
                } else if (!deliveryAvailable && clickCollectAvailable) {
                    buttonText = 'Pickup in Store';
                    shouldDisable = false;
                    productForm?.insertAdjacentHTML('beforeend', `<input type="hidden" name="properties[_is_cc]" value="Yes" id="ispickupstore">`);
                } else {
                    buttonText = 'Add to Cart';
                    shouldDisable = false;
                }
            } else if (inStoreOnlyWithRetail) {
                buttonText = 'Available in store only';
                shouldDisable = true;
            } else {
                buttonText = 'Out of Stock';
                shouldDisable = true;
            }

            this.updateDynamicCheckoutVisibility(!(deliveryAvailable || clickCollectAvailable));

            // Update all matching elements - re-query to catch dynamically rendered elements
            setTimeout(() => {
                const textElements = document.querySelectorAll('span[data-add-to-cart-text]');
                textElements.forEach(element => {
                    element.textContent = buttonText;
                });
                
                const buttons = document.querySelectorAll('button[data-add-to-cart]');
                buttons.forEach(button => {
                    if (shouldDisable) {
                        button.setAttribute('disabled', 'disabled');
                    } else {
                        button.removeAttribute('disabled');
                    }
                });
            }, 0);
        }

        updateDynamicCheckoutVisibility(shouldHide) {
            const applyVisibility = () => {
                document.querySelectorAll('.shopify-payment-button, .shopify-payment-button__more-options').forEach((element) => {
                    if (shouldHide) {
                        element.classList.add('hide');
                        element.setAttribute('aria-hidden', 'true');
                    } else {
                        element.classList.remove('hide');
                        element.removeAttribute('aria-hidden');
                    }
                });
            };

            applyVisibility();

            if (shouldHide) {
                [500, 1500].forEach((delay) => {
                    window.setTimeout(applyVisibility, delay);
                });
            }
        }

        async setStockAvailability(variantId, locationId) {
            const data = await this.getVariantAvailabilityByLocationId(variantId, locationId);
            if (data !== null) {
                this.ensureComponentVisible();
                const warehouseStatus = data.warehouseStockStatus || 'out-of-stock';
                this.currentWarehouseStatus = warehouseStatus;
                this.setStockStatusHtml(this.deliveryStatusElement, warehouseStatus);
                this.updateDeliveryTabState(warehouseStatus);
                this.updateFulfillmentVisibility(variantId, warehouseStatus);
                this.updateAddToCartButtonText(data);
                this.updateInStoreAvailability(variantId, warehouseStatus);

                if (!locationId || !this.currentStoreCookie) {
                    this.setClickCollectPanelWhenNoStore();
                    this.reCalculateAccordionHeight();
                    return;
                }

                this.setClickCollectStatusHtml(data, this.getStoreDisplayName(locationId));
            }

            this.reCalculateAccordionHeight();
        }
        
        toggleHide(element) {
            if (!element) return;
            element.classList.add('hide');
        }
        
        toggleShow(element) {
            if (!element) return;
            element.classList.remove('hide');
        }

        showPanelLayer(element) {
            if (!element) return;
            element.classList.remove('stock-display__panel--hidden');
        }

        hidePanelLayer(element) {
            if (!element) return;
            element.classList.add('stock-display__panel--hidden');
        }
        
        reCalculateAccordionHeight() {
            const accordionContent = this.closest('.accordion-content');
            if (accordionContent) {
                accordionContent.style.maxHeight = `${accordionContent.scrollHeight + 15}px`;
            }
        }
        
        setCookie(name, value, days = 7) {
            if (value === null || value === undefined) {
                document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/`;
                return;
            }

            const expires = new Date();
            expires.setTime(expires.getTime() + (days * 24 * 60 * 60 * 1000));
            const cookieValue = JSON.stringify(value);
            document.cookie = `${name}=${encodeURIComponent(cookieValue)};expires=${expires.toUTCString()};path=/`;
        }
        
        getCookie(name) {
            const nameEQ = name + "=";
            const ca = document.cookie.split(';');
            for (let i = 0; i < ca.length; i++) {
                let c = ca[i];
                while (c.charAt(0) === ' ') c = c.substring(1, c.length);
                if (c.indexOf(nameEQ) === 0) {
                    try {
                        return JSON.parse(decodeURIComponent(c.substring(nameEQ.length, c.length)));
                    } catch (e) {
                        console.error("Error parsing cookie value:", e);
                        return null;
                    }
                }
            }
            return null;
        }

        onVariantChange() {
            document.addEventListener('DOMContentLoaded', () => {
                const container1 = jQuery('[data-section-type="product"]');
                
                container1.on('variantChange', (event) => {
                    const variant = event.variant || event.detail?.variant;
                    
                    if (variant.id) {
                        this.dataset.variantId = variant.id;
                        this.currentVariantId = variant.id;
                        this.initialDeliveryStateSet = false;
                        this.closeInStoreAvailabilityModal();
                        this.closeInStorePanel();
                        this.setStockAvailability(variant.id, this.currentLocationId);
                        this.buildStoreList(variant.id);
                    }
                });
            });
        }
    }
    
    customElements.define('stock-display', StockDisplay);
}